import * as THREE from 'three'
import * as RAPIER from '@dimforge/rapier3d-compat'
import { Time } from '@core/Time'
import { Input } from '@core/Input'
import { AssetLoader } from '@core/AssetLoader'
import { Scene } from '@ecs/Scene'
import { EffectComposer } from 'three/examples/jsm/Addons.js'

type EngineCtor<T extends Engine> =
  new (data?: any) => T
export async function bootstrap<T extends Engine>(game: EngineCtor<T>) {
  await RAPIER.init()
  new game()
}
export abstract class Engine {
  canvas: HTMLCanvasElement | null
  renderer: THREE.WebGLRenderer
  composer: EffectComposer
  renderTarget: THREE.WebGLRenderTarget

  scene: Scene
  time: Time
  input: Input
  assetLoader: AssetLoader
  private _renderImageBuffer: Uint8Array
  private _renderImageBufferIsReading = false
  get renderImageBuffer() {
    this._renderImageBufferIsReading = true
    return this._renderImageBuffer
  }
  constructor() {
    this.canvas = document.querySelector('canvas.webgl') as HTMLCanvasElement | null

    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas || undefined,
      antialias: false
    })

    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


    this.renderer.shadowMap.enabled = true
    this.renderer.shadowMap.type = THREE.PCFShadowMap


    this.renderTarget = new THREE.WebGLRenderTarget(
      window.innerWidth,
      window.innerHeight,
      {
        format: THREE.RGBAFormat,
        type: THREE.UnsignedByteType, // si tu veux float
        minFilter: THREE.NearestFilter,
        magFilter: THREE.NearestFilter,
        depthBuffer: true,
        colorSpace: THREE.SRGBColorSpace,
      }
    );

    this.composer = new EffectComposer(this.renderer, this.renderTarget)
    //this.renderTarget
    this._renderImageBuffer = new Uint8Array(0)


    this.time = new Time()
    this.input = new Input(this)

    this.assetLoader = new AssetLoader()
    //console.log(this.assetLoader)

    this.scene = new Scene(this)
  }

  start() {
    window.addEventListener('resize', () => this.resize())

    this.update()
  }
  resize() {
    const width = window.innerWidth
    const height = window.innerHeight

    this.renderer.setSize(width, height)
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    this.composer.setSize(width, height)
    this.renderTarget.setSize(width, height)

    this.scene.resize(width, height)
  }

  update() {

    this.time.update()
    this.input.update()
    this.time.manageFixedUpdate(() => { this.scene.fixedUpdate(this.time.fixedDelta) })
    this.worldUpdate(this.time.delta)
    this.scene.update(this.time.delta)
    this.scene.render(this.time.delta)
    const mainCamera = this.scene.mainCamera
    if (mainCamera) {
      this.renderer.setRenderTarget(this.renderTarget)
      this.composer.render()
      this.renderer.setRenderTarget(null)

      if (this._renderImageBufferIsReading) {

        const size = new THREE.Vector2()
        this.renderer.getDrawingBufferSize(size)

        this._renderImageBuffer = new Uint8Array(size.x * size.y * 4)

        this.renderer.readRenderTargetPixels(
          this.composer.readBuffer,
          0,
          0,
          size.x,
          size.y,
          this._renderImageBuffer
        )
        this._renderImageBufferIsReading = false
      }

    }

    requestAnimationFrame(() => this.update())
  }
  worldUpdate(_dt: number) { }
}
